export default __webpack_public_path__ + "static/media/empty-banner.a48ef6fb.svg";